import {
  ActivityDurationData,
  ReadActivityDataListParams,
  ReadTeamDataItemsParams,
  SessionInfo,
  SpeedData,
} from "@/types/data"
import { useMutationHook, useQueryHook } from "@/hooks"
import {
  deleteMatchPlayer,
  readActivityDataList,
  readSessionData,
  readSpeedData,
  readTeamDataItems,
  upsertMatchPlayer,
} from "@/app/api/data"
import { createAccountStore } from "@/stores/account"
import { ApiError } from "@/app/api/type"
import { UseQueryOptions } from "@tanstack/react-query"

export const useTeamDataItemsQuery = (params: ReadTeamDataItemsParams) => {
  return useQueryHook({
    queryKey: ["teamDataItems", ...Object.values(params)],
    queryFn: async () => await readTeamDataItems(params),
  })
}

export const useActivityTeamDataListQuery = (params: ReadTeamDataItemsParams) => {
  return useQueryHook({
    queryKey: ["activityTeamDataList", ...Object.values(params)],
    queryFn: async () => await readTeamDataItems(params),
  })
}

export const useSpeedDataQuery = (idfData: number, enabled: boolean) => {
  return useQueryHook({
    queryKey: ["speedList", idfData],
    queryFn: async () => await readSpeedData(idfData),
    options: {
      enabled: enabled,
    } as UseQueryOptions<SpeedData, ApiError>,
  })
}

export const useSessionDataQuery = (idfData?: number) => {
  return useQueryHook({
    queryKey: ["sessionData", idfData],
    queryFn: async () => await readSessionData(idfData as number),
    options: {
      enabled: idfData !== undefined,
    } as UseQueryOptions<SessionInfo[], ApiError>,
  })
}

export const useUpsertMatchPlayerMutation = () => {
  return useMutationHook(upsertMatchPlayer, [["readAnalyzingActivity"]])
}

export const useDeleteMatchPlayerMutation = () => {
  return useMutationHook(deleteMatchPlayer, [["readAnalyzingActivity"]])
}

export const useActivityDataListQuery = (params: ReadActivityDataListParams) => {
  const { selectedIdfTeam } = createAccountStore((state) => ({
    selectedIdfTeam: state.selectedIdfTeam,
  }))

  return useQueryHook({
    queryKey: ["activityDataList", ...Object.values(params), selectedIdfTeam],
    queryFn: async () => await readActivityDataList(params),
    // 작은 데이터 확인용도. 빈딘QA 팀 2023년 7월 4일 데이터
    // queryFn: async () => {
    //   const { response, success, error } = await readActivityDataList(params)

    //   response?.unshift({
    //     dateStart: "2023-07-04T12:00:00.000Z",
    //     dateFinish: "2023-07-04T12:05:00.000Z",
    //   })

    //   return { response, success, error }
    // },
    options: {
      enabled: !!selectedIdfTeam,
    } as UseQueryOptions<ActivityDurationData[], ApiError>,
  })
}
